<div class="overlay"></div>
<div *ngIf="status == 0" class="modal-otp" (click)="$event.stopPropagation()">
    <div *ngIf="status == 0" class="modal-body">
        <img
            (click)="goBack()"
            src="../../../assets/login/arrow-left.png"
            alt="back"
            class="back"
        />
        <h2>{{ 'forgotPassword.title' | translate }}</h2>
        <p>
            {{ 'forgotPassword.description' | translate }}
        </p>
        <label>{{ 'forgotPassword.emailLabel' | translate }}<span class="error">*</span></label>
        <input
            type="email"
            placeholder="{{ 'forgotPassword.emailPlaceholder' | translate }}"
            [(ngModel)]="email"
            name="email"
            #emailRef="ngModel"
            required
            pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
        />
        <div class="error" *ngIf="emailRef.touched && emailRef.invalid">
            <div *ngIf="emailRef.errors?.required">{{ 'forgotPassword.errors.emailRequired' | translate }}</div>
            <div *ngIf="emailRef.errors?.pattern">
                {{ 'forgotPassword.errors.emailInvalid' | translate }}
            </div>
        </div>
        <p class="login-text">
            {{ 'forgotPassword.rememberAccount' | translate }} <span (click)="goBack()">{{ 'forgotPassword.login' | translate }}</span>
        </p>
        <button
            class="btn-otp-primary"
            [class.active]="emailRef?.valid"
            (click)="sendCode()"
        >
            {{ 'forgotPassword.sendCode' | translate }}
        </button>
    </div>
</div>

<div *ngIf="status == 1" class="modal-otp success-link" (click)="$event.stopPropagation()">
    <div class="modal-body">
        <div class="icon-success">
            <img src="../../../assets/login/reset-password.png" />
        </div>

        <h2>{{ 'resetPassword.title' | translate }}</h2>

        <p>
            {{ 'resetPassword.successMessage' | translate }}
        </p>

        <p class="back-text" (click)="goBack()">{{ 'resetPassword.backToLogin' | translate }}</p>
    </div>
</div>
